import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild, OnInit } from '@angular/core';

import { MenuItem } from './menu.model';
import { MENU } from './menu';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BaseComponent } from 'src/app/base/base/base.component';
import { takeUntil } from 'rxjs';

/* Models */
import { AdminMENU } from './admin-menu';

/* Services */
import { RoleDataService } from '../../core/services/role-data.service';
import { BaseService } from 'src/app/core/services/base.service';
import { TokenAuthService } from 'src/app/core/services/tokenauth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends BaseComponent implements OnInit {
  menu: any;
  toggle: any = true;
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  lastroute: any;
  isAdmin = false;

  // Menu
  menuItems: MenuItem[] = [];
  loadingMenu: boolean = false;

  // Logged In User
  currentuser = {} as any;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private roleDataService: RoleDataService,
    private tokenAuthService: TokenAuthService,
  ) {
    super();
    translate.setDefaultLang('ar');
  }

  ngOnInit(): void {
    this.loadingMenu = true;
    const currentUser = this.tokenAuthService.currentUserValue();
    this.currentuser = currentUser;


    // if (this.isAdmin == true) {
    //   this.menuItems = AdminMENU;
    // }
    // else {
    //   this.menuItems = MENU;
    // }

    this.roleDataService.getAccessiblePagesByUser(this.currentuser.userId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      (data: any) => {
        this.menuItems = data.result.returnData;
        this.loadingMenu = false;
      }
    )

    this.router.events.subscribe((event) => {
      if (document.documentElement.getAttribute('data-layout') == 'vertical' || document.documentElement.getAttribute('data-layout') == 'horizontal') {
        if (event instanceof NavigationEnd) {
          this.initActiveMenu();
          this.SidebarHide();
        }
      }
    });
  }

  /***
   * Activate droup down set
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.initActiveMenu();
    }, 0);
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }


  toggleItem(event: any) {
    const currentLink = event.target.closest('a.nav-link') as HTMLElement;
    if (!currentLink) return;
  
    const currentMenu = currentLink.nextElementSibling as HTMLElement | null;
    const nav = document.getElementById('navbar-nav');
    if (!nav || !currentMenu) return;
  
    const isOpen = currentMenu.classList.contains('show');
  
    const rootLinks = Array.from(
      nav.querySelectorAll(':scope > li > a.menu-link')
    ) as HTMLElement[];
  
    const rootMenus = Array.from(
      nav.querySelectorAll(':scope > li > .menu-dropdown')
    ) as HTMLElement[];
  
    rootLinks.forEach(link => {
      link.classList.remove('active');
      link.setAttribute('aria-expanded', 'false');
    });
  
    rootMenus.forEach(menu => {
      menu.classList.remove('show');
    });
  
    if (!isOpen) {
      currentMenu.classList.add('show');
      currentLink.classList.add('active');
      currentLink.setAttribute('aria-expanded', 'true');
  
      this.activateParentDropdown(currentLink);
    }
  }
  

  toggleSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;

    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });
      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  toggleExtraSubItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let isMenu = isCurrentMenuId.nextElementSibling as any;
    if (isMenu.classList.contains("show")) {
      isMenu.classList.remove("show");
      isCurrentMenuId.setAttribute("aria-expanded", "false");
    } else {
      let dropDowns = Array.from(document.querySelectorAll('.extra-sub-menu'));
      dropDowns.forEach((node: any) => {
        node.classList.remove('show');
      });

      let subDropDowns = Array.from(document.querySelectorAll('.menu-dropdown .nav-link'));
      subDropDowns.forEach((submenu: any) => {
        submenu.setAttribute('aria-expanded', "false");
      });

      if (event.target && event.target.nextElementSibling) {
        isCurrentMenuId.setAttribute("aria-expanded", "true");
        event.target.nextElementSibling.classList.toggle("show");
      }
    }
  };

  // Click wise Parent active class add
  toggleParentItem(event: any) {
    let isCurrentMenuId = event.target.closest('a.nav-link');
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    dropDowns.forEach((node: any) => {
      node.classList.remove('show');
    });
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    isCurrentMenuId.setAttribute("aria-expanded", "true");
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  activateParentDropdown(item: any) {
    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse")) {
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").classList.add("show");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.closest(".collapse").previousElementSibling.classList.add("active");
        }
      }
      return false;
    }
    return false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }

    this.activateParentDropdown(event.target);
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById('navbar-nav');
    if (!ul) return;
  
    const items = Array.from(ul.querySelectorAll('a.nav-link')) as HTMLElement[];
  
    items.forEach(item => {
      item.classList.remove('active');
      item.setAttribute('aria-expanded', 'false');
  
      const next = item.nextElementSibling as HTMLElement | null;
      if (next && next.classList.contains('collapse')) {
        next.classList.remove('show');
      }
    });
  
    const matchingMenuItem = items.find((x: any) => x.pathname === pathName);
  
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }
  

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    var sidebarsize = document.documentElement.getAttribute("data-sidebar-size");
    if (sidebarsize == 'sm-hover-active') {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover')
    } else {
      document.documentElement.setAttribute("data-sidebar-size", 'sm-hover-active')
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  /**
   * SidebarHide modal
   * @param content modal content
   */
  SidebarHide() {
    document.body.classList.remove('vertical-sidebar-enable');
  }


}
